//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fasInfo, fasQuestion } from '@quasar/extras/fontawesome-v5'
export default {
  name: 'Confirm',

  computed: {
    params() {
      return this.$store.state.confirm
    },
    confirmButtonText() {
      return this.params.okText || 'OK'
    },
    cancelButtonText() {
      if (this.params.cancelText === undefined) {
        return 'Cancel'
      }
      return this.params.cancelText || ''
    },
    icon() {
      let isQuestion = !!this.cancelButtonText
      return (
        this.params.icon || (isQuestion ? this.questionIcon : this.infoIcon)
      )
    }
  },

  methods: {
    confirm() {
      this.params.onConfirm()
    },
    cancel() {
      if (this.params) {
        if (this.cancelButtonText) {
          this.params.onCancel() // Only trigger cancel if cancel button available
        } else {
          this.params.onConfirm()
        }
      }
    }
  },

  created() {
    // Make FontAwesome SVG icons usable inside template
    this.infoIcon = fasInfo
    this.questionIcon = fasQuestion
  }
}
